module.exports = __webpack_public_path__ + "img/1.f9b1f1b1.png";